"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgExclamationTriangleOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M12.922 2.622c-.426-.83-1.418-.83-1.844 0l-8.91 17.354c-.454.88.067 2.024.921 2.024h17.822c.854 0 1.375-1.144.922-2.024l-8.91-17.354h-.001zm-.915 2.88L19.5 20H4.502l7.505-14.498zM10.5 17.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM11 14c0 .666.334 1 1 1 .667 0 1-.334 1-1v-4c0-.667-.333-1-1-1-.666 0-1 .333-1 1v4z' }))); };
exports.default = SvgExclamationTriangleOutline;
//# sourceMappingURL=ExclamationTriangleOutline.js.map